import React from 'react';

import AddonBenefits from './AddonBenefits';
import AddonWorkFlow from './AddonWorkFlow';
import AddonConsumerGuide from './AddonConsumerGuide';

const sectionComponents = {
  ICON: AddonBenefits,
  STEPPER: AddonWorkFlow,
  BULLET: AddonConsumerGuide,
};

const AddOnOverlayBody = ({ data, onTncClick }) => (
  <div className="addon-overlay-body">
    {data.map((section, index) => {
      const SectionComponent = sectionComponents[section.listConfig.type];
      return SectionComponent ? (
        <SectionComponent key={index} section={section} onTncClick={onTncClick} />
      ) : null;
    })}
  </div>
);

export default AddOnOverlayBody;
